import DeleteIcon from "@mui/icons-material/Delete";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import { Chip, IconButton, Paper, Typography, Box } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function InpatientStayVaccinationListing({
  vaccine,
  index,
  handleRemoveVaccine,
}) {
  const { t } = useTranslation();

  const getCategoryColor = (category) =>
    String(category).toUpperCase() === "RABIES" ? "error" : "primary";

  const catColor = getCategoryColor(vaccine.category);

  return (
    <Paper
      variant="outlined"
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1,
        pr: 1.5,
        mb: 1,
        bgcolor: "background.paper",
        borderColor: "divider",
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
        <Box sx={{ width: 36, display: "flex", justifyContent: "flex-start" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: `${catColor}.lighter`,
              borderRadius: 1,
              p: 0.5,
              width: 28,
              height: 28,
            }}
          >
            <VaccinesIcon
              fontSize="small"
              color={catColor}
              sx={{ fontSize: 18 }}
            />
          </Box>
        </Box>

        <Box sx={{ width: 200 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              pr: 1,
            }}
            title={vaccine.name} 
          >
            {vaccine.name}
          </Typography>
        </Box>

        <Box sx={{ width: 90 }}>
          <Chip
            label={t(vaccine.category)}
            size="small"
            color={catColor}
            variant="filled"
            sx={{
              width: 70,
              height: 24,
              "& .MuiChip-label": { px: 1, fontSize: "0.75rem" },
            }}
          />
        </Box>

        <Box sx={{ width: 100 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontFamily: "monospace",
              fontSize: "0.75rem",
            }}
          >
            {vaccine.date ? dayjs(vaccine.date).format("DD/MM/YYYY") : "—"}
          </Typography>
        </Box>

        <Box
          sx={{
            width: 40,
            display: "flex",
            justifyContent: "flex-end",
            ml: "auto",
          }}
        >
          <IconButton
            size="small"
            color="error"
            onClick={() => handleRemoveVaccine(index)}
            title={t("Delete")}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
}
